import {
    ADD_FAVOURITE_INITIATIVE_SUCCESS,
    FETCH_ALL_INITIATIVE_SUCCESS,
    FETCH_INITIATIVE_SUCCESS,
    FILTER_INITIATIVE,
    GET_ALL_INITIATIVE,
    GET_UNSELECTED_ALL_INITIATIVE,
    HANDLE_INITIATIVE_REQUEST_CLOSE,
    HIDE_INITIATIVE_LOADER,
    SHOW_INITIATIVE_LOADER,
    ON_ADD_INITIATIVE,
    ON_EDIT_INITIATIVE,
    ON_ALL_INITIATIVE_SELECT,
    ON_INITIATIVE_CLOSE,
    ON_INITIATIVE_SELECT,
    ON_DELETE_INITIATIVE_SUCCESS,
    ON_FILTER_SELECTED_INITIATIVE,
    ON_FILTER_INITIATIVE_OPTION_SELECT,
    ON_SAVE_INITIATIVE_SUCCESS,
    ON_TOGGLE_INITIATIVE_DRAWER,
    SHOW_INITIATIVE_MESSAGE,
    UPDATE_SEARCH_INITIATIVE,
    SET_INITIATIVE,
    CLEAR_SESSION,
    ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All initiatives';
export const STARRED_FILTER = 'Starred initiatives';
export const SUCCESSFUL_UPDATE = 'Initiative Updated Successfully';
export const SUCCESSFUL_FILTER = 'Initiative Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Initiative Deleted Successfully';
export const REMOVED_AS_STAR = 'Initiative removed as star';
export const MARKED_AS_STAR = 'Initiative marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No initiatives found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allInitiative: [],
    initiativeList: [],
    selectedInitiative: null,
    selectedInitiatives: 0,
    addInitiativeState: false,
    editInitiativeState: false,
    searchInitiative: '',
    productSelectionList: [],
    selectedProducts: 0,
    initiative: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedInitiative: null,
            };
        }
        case ON_FETCH_SELECT_PRODUCT_DATA_SUCCESS: {
            return {
                ...state,
                productSelectionList: action?.payload,
                loader: false,
            };
        }
        case SET_INITIATIVE: {
            const initiatives = state.allInitiative.filter((entry) => entry?.id === action?.payload);
            return {
                ...state,
                loader: false,
                selectedInitiative: initiatives?.length > 0 ? initiatives[0] : [],
            };
        }
        case ADD_FAVOURITE_INITIATIVE_SUCCESS: {
            const allUpdated = state.allInitiative.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                initiativeList: listUpdated,
                allInitiative: allUpdated,
            };
        }
        case FETCH_INITIATIVE_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedInitiative: action.payload,
                addInitiativeState: false,
                editInitiativeState: false,
            };
        }
        case FETCH_ALL_INITIATIVE_SUCCESS: {
            return {
                ...state,
                loader: false,
                allInitiative: action.payload,
                initiativeList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addInitiativeState: false,
                editInitiativeState: false,
            };
        }
        case SHOW_INITIATIVE_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_INITIATIVE_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedProducts = 0;
            const productSelectionList = state.productSelectionList.map(product => {
                if (product.selected) {
                    selectedProducts++;
                }
                if (product.id === action.payload.id) {
                    if (product.selected) {
                        selectedProducts++;
                    }
                    return action.payload;
                } else {
                    return product;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedProducts: selectedProducts,
                productSelectionList: productSelectionList
            };
        }
        case ON_ADD_INITIATIVE: {
            return {
                ...state,
                addInitiativeState: true,
                editInitiativeState: false,
            };
        }
        case ON_EDIT_INITIATIVE: {
            return {
                ...state,
                selectedInitiative: action.payload,
                editInitiativeState: true,
                addInitiativeState: false,
            };
        }
        case ON_INITIATIVE_CLOSE: {
            return {
                ...state,
                addInitiativeState: false,
                editInitiativeState: false,
            };
        }
        case ON_FILTER_INITIATIVE_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let initiativeList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    initiativeList = state.allInitiative;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    initiativeList = state.allInitiative.filter((initiative) => initiative.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, initiativeList, drawerState: false
            };
        }
        case ON_SAVE_INITIATIVE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                initiativeList: addOrUpdateEntry(state.initiativeList, action.payload),
                allInitiative: addOrUpdateEntry(state.allInitiative, action.payload),
                selectedInitiative: action.payload,
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_INITIATIVE_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allInitiative: state.allInitiative.filter((initiative) => initiative.id !== action.payload),
                initiativeList: state.allInitiative.filter((initiative) => initiative.id !== action.payload),
                selectedInitiative: null,
            };
        }
        case ON_FILTER_SELECTED_INITIATIVE: {
            const initiatives = state.allInitiative.filter((initiative) => !initiative.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                initiativeList: initiatives,
                selectedInitiatives: 0
            };
        }
        case FILTER_INITIATIVE: {
            const { filterOption } = state;
            let initiativeList = [];
            if (action.payload === '') {
                initiativeList = state.allInitiative;
            } else {
                const filterInitiative = state.allInitiative.filter((initiative) =>
                    initiative.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    initiativeList = filterInitiative;
                } else if (filterOption === STARRED_FILTER) {
                    initiativeList = filterInitiative.filter((initiative) => initiative.starred);
                }
            }
            return { ...state, initiativeList: initiativeList };
        }
        case GET_ALL_INITIATIVE: {
            let initiativeList = state.allInitiative.map((initiative) => initiative ? {
                ...initiative,
                selected: true
            } : initiative);
            return {
                ...state,
                selectedInitiatives: initiativeList.length,
                allInitiative: initiativeList,
                initiativeList: initiativeList
            };
        }
        case GET_UNSELECTED_ALL_INITIATIVE: {
            let initiativeList = state.allInitiative.map((initiative) => initiative ? {
                ...initiative,
                selected: false
            } : initiative);
            return {
                ...state,
                selectedInitiatives: 0,
                allInitiative: initiativeList,
                initiativeList: initiativeList
            };
        }
        case ON_ALL_INITIATIVE_SELECT: {
            const selectAll = state.selectedInitiatives < state.initiativeList.length;
            let selectedInitiatives = 0;
            let initiativeList = [];
            if (selectAll) {
                initiativeList = state.allInitiative.map((initiative) => initiative ? {
                    ...initiative,
                    selected: true
                } : initiative);
                selectedInitiatives = initiativeList.length;
            } else {
                initiativeList = state.allInitiative.map((initiative) => initiative ? {
                    ...initiative,
                    selected: true
                } : initiative);
                selectedInitiatives = 0;
            }
            return {
                ...state,
                selectedInitiatives: selectedInitiatives,
                allInitiative: initiativeList,
                initiativeList: initiativeList
            };
        }
        case UPDATE_SEARCH_INITIATIVE: {
            return { ...state, searchInitiative: action.payload };
        }
        case HANDLE_INITIATIVE_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_INITIATIVE_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_INITIATIVE_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_INITIATIVE_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/initiative.js